import {
  awardsDialog,
  tutorialDialog,
  rulesDialog,
} from "../../alertContents/index";
import GamePadIcon from "../../../../assets/images/icons/gamePadIcon.svg";
import InfoIcon from "../../../../assets/images/icons/greenInfoIcon.svg";
import DartIcon from "../../../../assets/images/icons/DartIcon.svg";
import SymbolIcon from "../../../../assets/images/icons/SymbolIcon.svg";
import RulesIcon from "../../../../assets/images/icons/PurplePaperIcon.svg";
import ProfileIcon from "../../../../assets/images/icons/blueProfileIcon.svg";
import SquaresIcon from "../../../../assets/images/icons/FourSquaresIcon.svg";
import HistoryIcon from "../../../../assets/images/icons/booking-history .svg";
import AwardIcon from "../../../../assets/images/icons/award.svg";

export const menuItems = [
  {
    icon: GamePadIcon,
    text: "شروع چالش",
    width: "full",
    link: "/questions/123",
    disable: false,
  },
  {
    icon: AwardIcon,
    text: "پله بارون",
    width: "half",
    link: "/pelebaroon",
  },
  {
    icon: SquaresIcon,
    text: "جدول پیشتازان",
    width: "half",
    link: "/leaderboard",
  },
  {
    icon: InfoIcon,
    text: "راهنما‌ی چالش",
    width: "half",
    content: tutorialDialog,
  },
  {
    icon: DartIcon,
    text: "ماموریت ها",
    width: "half",
    link: "/quests",
    disable: false,
    showNew: true,
  },

  {
    icon: SymbolIcon,
    text: "جوایز",
    width: "half",
    content: awardsDialog,
  },
  {
    icon: RulesIcon,
    text: "قوانین",
    width: "half",
    content: rulesDialog,
  },
  {
    icon: ProfileIcon,
    text: "پروفایل",
    width: "half",
    link: "/profile",
  },
  {
    icon: HistoryIcon,
    text: "تاریخچه پله‌ها",
    width: "full",
    link: "/scoreHistory",
  },
];
